const i18n = {
    'en': {
        // gene
        'protein': 'Protein',
        'metabon': 'Metabolite',
        'gene': 'Gene',
        'MIDcount': 'MIDs',
        'E10': 'E10',
        'geneName': 'Gene',
        'cellCount': 'Cells',
        'expCount': 'MIDs',
        'common_colors': 'Common Colors',
        'total_mid_count': 'Total MID Count',
        'total_intensity': 'Total Intensity',
        'intensity': 'Intensity',
        'previous_page': 'Prev',
        'next_page': 'Next',
        'layer': 'Layer',
        'image_layer': 'Image Layer',
        'IF_protein_layer': 'IF Protein Layer',
        // 'ssDNA': 'ssDNA',
        // 'TissueCut': 'tissuemask',
        // 'CellMask': 'cellmask',
        'main_analysis_layer': 'Main Analysis Layer',
        'gene_heatmap_layer': 'Gene Heatmap',
        'protein_heatmap_layer': 'Protein Heatmap',
        'metabon_heatmap_layer': 'Metabolite Heatmap',
        'cell_cluster_layer': 'Cluster',
        'bin_cluster_layer': 'Cluster',
        'protein_expression_layer': 'Protein Expression Layer',
        'scale_bar': 'Scale Bar',
        'color_bar': 'Color Bar',
        'statistics': 'Floating Info',
        'clustering_parameter': 'Statistics',
        'thumbnail': 'Thumbnail',
        'umap': 'UMAP',
        'UMAP': 'UMAP',
        'rotate': 'Rotate',
        'brightness': 'Brightness',
        'contrast': 'Contrast',
        'opacity': 'Opacity',
        'clustering': 'Clustering',
        'cell_count': 'Cell Count',
        'bin_count': 'Bin Count',
        'legend': 'Legend',
        'legend_image': 'Legend of Image',
        'legend_cluster': 'Legend of Cluster',
        'return_to_previous_page': 'Return to Previous Page',
        'undo': 'Undo',
        'rset': 'Reset',
        'cursor': 'Cursor',
        'turnOff': 'Turn off',
        'registration_with_track_line': 'Registration with Track Line',
        'registration_without_track_line': 'Registration without Track Line',
        'lasso': 'Lasso',
        'filter': 'Filter',
        'comments': 'Comments',
        'registration_template': 'Registration Template',
        'save': 'Save a Status File',
        'load': 'Load Status File',
        'original_image': 'Original Image',
        'download': 'Download',
        'gene_mid_threshold': 'Gene MID Threshold',
        'annotation_text': 'Annotation Text',
        'text_color': 'Text Color',
        'resolution': 'Resolution',
        'center': 'Center',
        'mousePosition': 'Mouse Position',
        'enlarge': 'enlarge',
        'minus': 'narrow',
        'geneReset': 'RESET',
        'normalized': 'Normalization',
        'Opacity': 'Opacity',
        'Opacity (on)': 'Opacity',
        'oFactor': 'Opacity',
        'sizeFactor': 'Spot Size',
        // IF配准
        'if_sign': 'Enter mark point mode',
        'if_submit': 'Submit',
        // data_panel_layout
        'repetitionTagName': 'Duplicate tag name',
        'switchV2': 'Switch to StereoMap V2',
        'switchInfo': 'Switch to V2',
        'color': 'Color',
        'commonColors': 'Common colors',
        'reset': 'Reset',
        'settings': 'Setting',
        'dialogSave': 'Save',
        'dialogLabel': 'Please enter a label',
        'label': 'Label',
        'status_record': 'Status Record',
        'lasso_record': 'Lasso Record',
        'lasso_record_limit': 'Currently only the latest 10 records are kept',
        'record_index': 'Number',
        'record_label': 'Label',
        'record_time': 'Time',
        'lassoload': 'Lasso Load',
        'statu_span': 'Load a Status Record',
        'lasso_span': 'Load a Lasso Record',
        'binsizeAuto': 'Auto-binsize',
        'location': 'Location',
        'more_details': 'Double click for more details.',
        'display_scheme': 'Display Schemes',
        'multi_color': 'Multi-colored',
        'heat_map': 'HeatMap',
        'midCount': 'MID Count',
        'geneCount': 'Gene Type',
        'id': 'Cell ID',
        'area': 'Area',
        'clusterID': 'Cluster ID',
        'detail_of_bin': 'Details of Bin',
        'gene_type': 'Gene Type',
        'metabon_type': 'Metabolite Type',
        'cluster_count': 'Cluster Count',
        'mid_count': 'MID Count',
        'Loading': 'Loading...',
        'cellTypeID': 'Cell Type',
        'c': 'Cluster',
        'autoOptimization': 'Optimization',
        'autoOptimizationInfo': 'When cluster(s) is checked, the opacity of Image Layer will be automatically multiplied by this value, in order to highlight the cluster layer.',
        'cancel': 'Cancel',
        'confirm': 'Confirm',
        'open': 'Open',
        'newFiles': 'New Files',
        'addFiles': 'Add Files',
        'genePanelGeneSearch': 'Please enter Gene Symbol',
        'genePanelProteinSearch': 'Please enter Protein Symbol',
        'genePanelMetabonSearch': 'Please enter metabolite ID',
        'genePanelSelectedGene': 'Selected',
        'genePanelAll': 'All',
        'genePanelShow': 'Show gene panel',
        'genePanelHide': 'Hide gene panel',
        'genePanelAttop': `It's at the top!`,
        'genePanelAtbottom': `It's at the bottom!`,
        'genePanelFirstpage': "It's the first page!",
        'genePanelLastpage': "It's the last page!",
        'genePanelIllegalpage': 'Illegal page number entered!',
        'layerPanelShow': 'Show layer panel',
        'layerPanelHide': 'Hide layer panel',
        'layerPanleDefault': 'Default',
        'layerPanelCustomized': 'Customized',
        'layerPanelFormCell': 'Form of cells',
        'layerPanelFilled': 'Filled',
        'layerPanelOutlined': 'Outlined',
        'layerPanelNone': 'None',
        'layerPanelBoth': 'Both',
        'layerPanelOutlineColor': 'Outline color',
        'layerPanelTissueOutline': 'Tissue Outlined',
        'layerPanelCluster': 'Cluster',
        'layerPanelWhite': 'White',
        'layerPanelBlack': 'Black',
        'layerPanelGreen': 'Green',
        'layerPanelImage': 'Image',
        'layerPanelTissueMask': 'TissueMask',
        'layerPanelCellMask': 'CellMask',
        'layerPanelcell_cluster_layer': 'Cluster',
        'layerPanelTissueCut': 'CellMask',
        'layerPanelssDNA': 'Image',
        'layerPanelUMAP': 'Cluster&UMAP',
        'binsziePanelShow': 'Show binszie panel',
        'binsziePanelHide': 'Hide binsize panel',
        'registrationPanelLayer': 'Registration Layer',
        'registrationPanelStepsize': 'Step Size',
        'registrationPanelTune': 'Fine Tuning',
        'registrationPanelFile': 'Flip',
        'registrationPanelRotate90': '90° Rotation',
        'registrationPanelRotate': 'Rotate',
        'registrationPanelInfo': 'We do not recommend to adjust this parameter if your data has passed Quality Control.',
        'registrationPanelScalex': 'Scale-X',
        'registrationPanelScaley': 'Scale-Y',
        'registrationPanelStepsizeEmpty': 'Please enter Step Size!',
        'registrationPanelFilePath': 'The file path is ',
        'registrationPanelTask': 'Please go to Workflow to deliver the task.',
        'registrationPanelDataManagement': 'Data Management',
        'registrationPanelRegisterSuccess': 'Saved successfully!',
        'lassoPanelHoldCtrl': 'Hold Ctrl to add the area. ',
        'lassoPanelHoldAlt': 'Hold Alt to remove the area.',
        'lassoPanelRightClick': 'Right-click to add outline point',
        'lassoPanelEnterConfrom': 'Press Enter to confirm. ',
        'lassoPanelDBClick': 'Double-click to select the area.',
        'lassoPanelInputLabel': 'Please enter label name',
        'lassoPanelPatter': 'Label names only support English letters, underscores and numbers!',
        'lassoPanelDuplicate': 'Duplicate label detected, merge or not?',
        'lassoPanelTotalArea': 'Total Area: ',
        'lassoPanelTotalMIDCount': 'Total MID Count: ',
        'lassoPanelMeanMID': 'Mean/Median MID Count: ',
        'lassoPanelMeanIntensity': 'Mean/Median Intensity: ',
        'lassoPanelMeanGene': 'Mean/Median Gene Types: ',
        'lassoPanelMeanMetabolite': 'Mean/Median Metabolite Type: ',
        'lassoPanelCellCount': 'Cell Count: ',
        'lassoPanelMeanArea': 'Mean/Median Area: ',
        'lassoPanelMeanDNB': 'Mean/Median DNB Count: ',
        'lassoPanelCellID': 'Cell ID',
        'lassoPanelMID': 'MID',
        'lassoPanelArea': 'Area: ',
        'lassoPanelExit': 'Exit lasso.',
        'lassoPanelCluster': 'Cluster',
        'lassoPanelAdd': 'Add',
        'lassoPanelRun': 'Run',
        'lassoPanelDelete': 'Delete',
        'lassoPanelInfo': 'Info',
        'lassoPanelGene': 'Gene',
        'lassoPanelCell': 'Cell Count: ',
        'lassoPanelFirst': 'Please lasso first!',
        'lassoPanelTotal': 'Total',
        'lassoPanelSelectlasso': 'Select Lasso',
        'lassoPanelLess3': 'The contour point data of the current lasso is less than 3, and the task is not allowed to be deliverec',
        'lassoPanelLeastone': 'Keep at least one!',
        'lassoPanelTask': 'The task ID is: ',
        'lassoPanelSelectBin': 'Select bin size: ',
        'lassoPanelContinue': 'Continue',
        'lassoPanelNewLabel': 'Label Name: ',
        'stateOperatePanelSaveUp10': 'Save up to 10 states, there are currently 10 states, and continuing to save will overwrite the earliest state!',
        'stateOperatePanelSuccess': 'Status saved successfully!',
        'stateOperatePanelSelectStatu': 'Please select a record to load!',
        'exportPanelDownload': 'Download',
        'exportPanelFilename': 'File name:',
        'exportPanelFilenamePlace': 'Custom file name',
        'exportPanelImagesize': 'Export lmage Options:',
        'exportPanelScreenshot': 'Screenshot Image',
        'exportPanelHD' : 'HD Image',
        'exportPanelExport': 'Export',
        'exportPanelSize': 'Export HD image scale: ',
        'exportPanelTakeTime': 'This may take a while to exporting HD image! Please do not switch windows during the export process to avoid image data errors!<br/>Also you can press ESC to exit the HD image export process!',
        'asyncfail': 'Fail: ',
        'nodata': 'No Data',
        'contactAdmin':'Error, please contact the administrator!',
        'pleaseLogin': 'No permission token, please login!',
        'pleaseInteger': 'Please enter an integer.',
        'maximumOnline':'Maximum value exceeds Online.',
        'maximumError': 'Maximum value input error.',
        'notice': 'Notice',
        'measure': 'Measure',
        'resolution_parameter': 'Resolution',
        'resetNotice': "The operations performed won't be retained Are you sure to refresh the page?",
        'taskId': 'Task ID:',
        'fileName': 'File Name:',
        'openedRepeatedly': 'has been opened repeatedly.',
        'balance': 'Insufficient balance, please recharge!',
        'proteinCount': 'Protein Type',
        'protein_type': 'Protein Type',
        'name_count': 'Count',
        'protein_count': 'Protein Count',
        'gene_count': 'Gene Count',
        'genePanelSearch': 'Search',
        'genePanelStateOutput': 'Whether to save or output the matrix directly?',
        'genePanelStateDatapath': '* The file would be saved as a JSON file in "Filter" folder under the current data path.Please select the parameters to be filtered and then choose to export.',
        'genePanelStateSaveOutput': 'Save and output',
        'genePanelStateSave': 'Export',
        'genePanelStateSaveTips': 'Export MID Filter File',
        'layerPanelprotein_heatmap': 'Protein Heatmap',
        'layerPanelprotein_heatmap_layer': 'Protein Heatmap',
        'layerPanelManyProtein': 'Multi window display',
        'binsizePanleHide': 'Hide binsize panel',
        'lassoPanelMeanProtein': 'Mean/Median Protein Types: ',
        'pleaseSelectStaut': 'Please selecte a status file in "Status" folder',
        'pleaseSelectLasso': 'Please selecte a lasso file in "Lasso" folder',
        'pleaseSelectLassoLabel': 'Lasso files in multiple labels are not currently supported！Please select a lasso file with one label',
        'goHomeNotice': 'Please confirm whether to return because the data will not be saved ?',
        'proteinName': 'Protein',
        'running': 'Running',
        'midFilter': 'Filter',
        'intensityFilter': 'Intensity Filter',
        'noMatchBinszie': 'no match binsize!',
        'transcript_omics_layer': 'Transcriptomics',
        'protein_omics_layer': 'Proteomics',
        'metabon_omics_layer': 'Metabolite',
        'Multiomics': 'Multiomics',
        'retry': 'Retry',
        'retryAll': 'Retry All',
        'importGeoJson': 'Import File',
        'importGeoJsonTitle': 'Supports the import of geojson files directly annotated by QUPATH software and lasso, and can directly output the matrix corresponding to contour points.',
        'outputLabelGefNote': 'Do you want to output the matrix of the marked area directly?',
        'outputLabelGefPathNote': 'The output files will be saved in the <i>Label</i> directory of the <i>StereoMapWorkSpace</i> installation path. Such as: <i>D: StereoMapWorkSpace/Label path.</i>',
        'saveGeojson': 'Save geojson File',
        'geojsonlabelLimit1': 'The system detects that the number of labels is ',
        'geojsonlabelLimit2': ', which exceeds the original value (',
        'geojsonlabelLimit3': ' labels).',
        'saveAndOutputMatrix': 'Save And Output',
        'outputMatrixTips': 'If you want to export gef, please select the heat map analysis layer.',
        'preparingData': 'Preparing data',
        'filterData': 'Data is being filtered',
        'processingData': 'Data is being processed and written to a gef file',
        'unknownTaskError': 'The task is terminated abnormally due to an unknown error.',
        'programError': 'The program is abnormal.',
        'taskNoFound': 'The system cannot find the corresponding task.',
        'unknownError': 'An unknown error occurs in the system. ',
        'waiting': 'Waiting',
        'labelsCount': 'LabelsCount:',
        'note': 'Note',
        'complete': 'complete',
    },
    'zh-CN': {
        // gene
        'protein': '蛋白',
        'metabon': '代谢物',
        'gene': '基因',
        'MIDcount': 'MID数',
        'E10': 'E10',
        'geneName': '基因',
        'cellCount': '细胞数',
        'expCount': 'MID数',
        'common_colors': '常用色',
        'total_mid_count': '总MID数',
        'total_intensity': '总强度',
        'intensity': '强度',
        'previous_page': '上一页',
        'next_page': '下一页',
        'layer': '图层选择',
        'image_layer': '图像图层',
        'IF_protein_layer': '蛋白IF图层',
        // 'ssDNA': 'ssDNA',
        // 'TissueCut': '组织分割',
        // 'CellMask': '细胞分割',
        'main_analysis_layer': '分析结果图层',
        'gene_heatmap_layer': '基因表达热图',
        'protein_heatmap_layer': '蛋白表达热图',
        'metabon_heatmap_layer': '代谢物表达热图',
        'cell_cluster_layer': '细胞聚类',
        'bin_cluster_layer': '聚类图层',
        'protein_expression_layer': '蛋白表达',
        'scale_bar': '标尺',
        'color_bar': '比色卡',
        'statistics': '悬浮信息',
        'clustering_parameter': '统计',
        'thumbnail': '缩略图',
        'umap': 'UMAP',
        'UMAP': 'UMAP',
        'rotate': '旋转角度',
        'brightness': '亮度调节',
        'contrast': '对比度调节',
        'clustering': '聚类',
        'cell_count': '细胞总数',
        'bin_count': 'Bin数量',
        'legend': '图例',
        'legend_image': '图像图例',
        'legend_cluster': '聚类图例',
        'return_to_previous_page': '返回主页',
        'undo': '撤销',
        'rset': '重置',
        'cursor': '游标',
        'turnOff': '关闭',
        'registration_with_track_line': '有track线配准',
        'registration_without_track_line': '无track线配准',
        'lasso': '套索',
        'filter': '条件过滤',
        'comments': '批注',
        'registration_template': '配准模板',
        'save': '保存',
        'load': '读取',
        'original_image': '原图',
        'download': '下载',
        'gene_mid_threshold': '基因MID阈值',
        'annotation_text': '注释文本',
        'text_color': '字体颜色选择',
        'resolution': '分辨率',
        'center': '中心位置',
        'mousePosition': '鼠标位置',
        'enlarge': '放大',
        'minus': '缩小',
        'geneReset': '重置',
        'normalized': '归一化',
        'Opacity': '透明度',
        'Opacity (on)': '透明度',
        'oFactor': '透明度',
        'sizeFactor': '散点大小',
        // IF配准
        'if_sign': '进入标点模式',
        'if_submit': '提交',
        // data_panel_layout
        'repetitionTagName': '重复标签名',
        'switchV2': '切换至StereoMap V2',
        'switchInfo': '切换至V2',
        'color': '颜色',
        'commonColors': '常用颜色',
        'reset': '重置',
        'settings': '设置',
        'dialogSave': '保存',
        'dialogLabel': '请输入名称',
        'label': '标签',
        'status_record': '状态记录',
        'lasso_record': '套索记录',
        'lasso_record_limit': '当前仅保留最新10条记录',
        'record_index': '序号',
        'record_label': '名称',
        'record_time': '时间',
        'lassoload': '套索回导',
        'statu_span': '导入状态记录',
        'lasso_span': '导入套索记录',
        'binsizeAuto': '自动',
        'location': '坐标',
        'more_details': '双击获取更多信息.',
        'display_scheme': '展示方案',
        'multi_color': '伪彩图',
        'heat_map': '热图',
        'midCount': 'MID数量',
        'geneCount': '基因种类',
        'id': '细胞ID',
        'area': '面积',
        'clusterID': '聚类ID',
        'detail_of_bin': 'Bin 信息',
        'gene_type': '基因种类',
        'metabon_type': '代谢物种类',
        'cluster_count': '聚类数量',
        'mid_count': 'MID数量',
        'Loading': '加载中...',
        'cellTypeID': '细胞注释',
        'c': '聚类',
        'autoOptimization': '效果增强',
        'autoOptimizationInfo': '勾选聚类后，图像图层的透明度乘以此数值，以突出展示聚类图层。',
        'cancel': '取消',
        'confirm': '确认',
        'open': '打开',
        'newFiles': '打开新文件',
        'addFiles': '新增文件',
        'genePanelGeneSearch': '请输入基因名称',
        'genePanelProteinSearch': '请输入蛋白名称',
        'genePanelMetabonSearch': '请输入代谢物ID',
        'genePanelSelectedGene': '已选',
        'genePanelAll': '全部',
        'genePanelShow': '展开基因面板',
        'genePanelHide': '收起基因面板',
        'genePanelSelectBinsize': '请选择binsize',
        'genePanelAttop': '已经是最顶部',
        'genePanelAtbottom': '已经是最底部',
        'genePanelFirstpage': "已经是第一页",
        'genePanelLastpage': "已经是最后一页",
        'genePanelIllegalpage': '不合法的页码',
        'layerPanelShow': '展开图层面板',
        'layerPanelHide': '收起图层面板',
        'layerPanleDefault': '默认',
        'layerPanelCustomized': '自定义',
        'layerPanelFormCell': '细胞样式',
        'layerPanelFilled': '填充',
        'layerPanelOutlined': '轮廓',
        'layerPanelBoth': '填充&轮廓',
        'layerPanelOutlineColor': '轮廓颜色',
        'layerPanelCluster': '聚类颜色',
        'layerPanelTissueOutline': '组织轮廓',
        'layerPanelNone': '无',
        'layerPanelWhite': '白色',
        'layerPanelBlack': '黑色',
        'layerPanelGreen': '绿色',
        'layerPanelImage': '影像图',
        'layerPanelTissueMask': '组织Mask',
        'layerPanelCellMask': '细胞Mask',
        'layerPanelcell_cluster_layer': '聚类',
        'layerPanelTissueCut': '组织Mask',
        'layerPanelssDNA': '影像图',
        'layerPanelUMAP': '聚类&UMAP',
        'binsziePanelShow': '展开binszie面板',
        'binsziePanelHide': '收起binsize面板',
        'registrationPanelLayer': '配准图层',
        'registrationPanelStepsize': '步长',
        'registrationPanelTune': '微调',
        'registrationPanelFile': '水平翻转',
        'registrationPanelRotate90': '90°旋转',
        'registrationPanelRotate': '旋转',
        'registrationPanelInfo': '如果您的数据已通过图像质控，不建议调整此参数。',
        'registrationPanelScalex': 'X轴尺度',
        'registrationPanelScaley': 'Y轴尺度',
        'registrationPanelStepsizeEmpty': '请输入步长',
        'registrationPanelFilePath': '文件路径: ',
        'registrationPanelTask': '请前往流程分析投递任务',
        'registrationPanelDataManagement': '数据管理',
        'registrationPanelRegisterSuccess': '保存成功！',
        'lassoPanelHoldCtrl': '按住Ctrl增加区域。',
        'lassoPanelHoldAlt': '按住Alt清除区域。',
        'lassoPanelRightClick': '鼠标右键点击增加轮廓点。',
        'lassoPanelEnterConfrom': '按下Enter确认区域。',
        'lassoPanelDBClick': '双击选中区域。',
        'lassoPanelInputLabel': '请输入标签名称',
        'lassoPanelForexample': '例如: ',
        'lassoPanelPatter': '标签名称仅支持英文字母、下划线和数字！',
        'lassoPanelDuplicate': '标签名称重复，是否合并？',
        'lassoPanelTotalArea': '总面积: ',
        'lassoPanelTotalMIDCount': '总MID数： ',
        'lassoPanelMeanMID': '平均/中位MID数：',
        'lassoPanelMeanIntensity': '平均/中位强度：',
        'lassoPanelMeanGene': '平均/中位基因种类：',
        'lassoPanelMeanMetabolite': '平均/中位代谢物种类：',
        'lassoPanelCellCount': '细胞数：',
        'lassoPanelMeanArea': '平均/中位细胞面积：',
        'lassoPanelMeanDNB': '平均/中位 DNB数: ',
        'lassoPanelCluster': '聚类',
        'lassoPanelCellID': '细胞ID',
        'lassoPanelMID': 'MID数',
        'lassoPanelArea': '面积: ',
        'lassoPanelExit': '退出套索',
        'lassoPanelAdd': '增加',
        'lassoPanelRun': '运行',
        'lassoPanelDelete': '删除',
        'lassoPanelInfo': '详情',
        'lassoPanelGene': '基因',
        'lassoPanelCell': '细胞数: ',
        'lassoPanelFirst': '请套索!',
        'lassoPanelTotal': '总数',
        'lassoPanelSelectlasso': '选择套索',
        'lassoPanelLess3': '由于套索的轮廓点小于3，套索的任务将不允许提交。',
        'lassoPanelLeastone': '至少保留一个',
        'lassoPanelTask': '任务ID是：',
        'lassoPanelSelectBin': '请选择bin',
        'lassoPanelContinue': '继续',
        'lassoPanelNewLabel': 'Label名称: ',
        'stateOperatePanelSaveUp10': '因系统最多保存10个状态，继续保存会覆盖最早的状态',
        'stateOperatePanelSuccess': '状态保存成功！',
        'stateOperatePanelSelectStatu': '请选择！',
        'exportPanelDownload': '下载',
        'exportPanelFilename': '文件名: ',
        'exportPanelFilenamePlace': '自定义文件名',
        'exportPanelImagesize': '导出图像选项: ',
        'exportPanelScreenshot': '截图',
        'exportPanelHD' : '高清图片',
        'exportPanelExport': '导出',
        'exportPanelSize': '导出高清图的比例: ',
        'exportPanelTakeTime': '导出该高清图可能需要花费一些时间。为避免导出错误，在导出图片的过程中请不要切换窗口，也可以按键盘“ESC”键退出高清图像的导出。',
        'asyncfail': '失败了：',
        'nodata': '暂无数据',
        'contactAdmin': '失败了，请联系管理员',
        'pleaseLogin': '登录信息过期，请重新登陆。',
        'pleaseInteger': '请输入正整数.',
        'maximumOnline':'最大值超过上限',
        'maximumError': '输入值有误',
        'notice': '提示',
        'resolution_parameter': '分群颗粒度',
        'measure': '测量',
        'resetNotice': '执行的操作将不会保留，请确认是否要刷新页面？',
        'taskId': '任务ID:',
        'fileName': '文件名:',
        'openedRepeatedly': '已经重复打开。',
        'balance': '余额不足，请充值！',
        'proteinCount': '蛋白种类',
        'protein_type': '蛋白种类',
        'name_count': '数量',
        'protein_count': '蛋白数量',
        'gene_count': '基因数量',
        'proteinName': '蛋白',
        'genePanelSearch': '搜索',
        'genePanelStateOutput': '是否输出矩阵文件？',
        'genePanelStateDatapath': '* 过滤的输出文件（json）将会保存在Filter文件夹中，请选择待过滤的参数后再选择导出。',
        'genePanelStateSave': '输出',
        'genePanelStateSaveTips': '输出MID过滤文件',
        'genePanelStateSaveOutput': '保存和输出',
        'layerPanelprotein_heatmap': '蛋白表达热图',
        'layerPanelprotein_heatmap_layer': '蛋白表达热图',
        'layerPanelManyProtein': '多窗口展示',
        'clusterPanelShow': '展开Cluster面板',
        'clusterPanelHide': '收起Cluster面板',
        'lassoPanelMeanProtein': '平均/中位蛋白种类：',
        'pleaseSelectStaut': '请选择状态文件',
        'pleaseSelectLasso': '请选择套索文件',
        'pleaseSelectLassoLabel': '请选择一个lasso文件状态导入，当前不支持2个及以上的文件。',
        'goHomeNotice': '返回主页数据将不会被保存，请确认是否返回？',
        'running': '运行中',
        'midFilter': '过滤',
        'intensityFilter': '强度过滤',
        'noMatchBinszie': '没有匹配的binsize',
        'transcript_omics_layer': '转录组',
        'protein_omics_layer': '蛋白组',
        'metabon_omics_layer': '代谢物',
        'Multiomics': 'Multiomics',
        'retry': '重试',
        'retryAll': '全部重试',
        'importGeoJson': '导入轮廓点文件',
        'importGeoJsonTitle': '支持QUPATH软件直接标注后及lasso后的geojson文件的导入，可直接输出轮廓点对应的矩阵。',
        'outputLabelGefNote': '请确认是否直接输出标注区域的矩阵？',
        'outputLabelGefPathNote': '输出的文件将会保存在软件安装路径<i>StereoMapWorkSpace</i>的<i>Label</i>目录下。比如：<i>D:StereoMapWorkSpace/Label</i>路径下。',
        'saveGeojson': '保存geojson文件',
        'geojsonlabelLimit1': '系统检测到标记的label数量为',
        'geojsonlabelLimit2': '个，已超出原始设置的label数量（',
        'geojsonlabelLimit3': '个）。',
        'saveAndOutputMatrix': '保存和输出矩阵',
        'outputMatrixTips': '请选择热图分析图层，方可导出gef。',
        'preparingData': '正在准备数据',
        'filterData': '正在过滤数据',
        'processingData': '正在处理数据并写入gef文件',
        'unknownTaskError': '任务发生了未知的错误，被异常终止。',
        'programError': '程序异常。',
        'taskNoFound': '系统找不到对应任务',
        'unknownError': '系统发生了未知错误',
        'waiting': '等待中',
        'note': '提示',
        'complete': '完成',
    }
}

let lang = window.sessionStorage.getItem('lang') || (window.location.href.includes('lang=zh-CN') ? 'zh-CN' : 'en');
// // let lang = 'zh';
// export default i18n[lang] || i18n['cn']
// let lang = 'en';
export default i18n[lang] || i18n['en']
